import BaseCard from 'components/Cards/BaseCard';
import DeviceSetting from '../../../../../components/DeviceSetting/DeviceSetting';
import { CARD_CLASS_NAMES } from '../../../../../config/floodDeviceConfig';

const SIMPLE_THRESHOLDS = [
  {
    settingName: 'Depth Detection Threshold 1',
    field: 'depthDet1',
    metric: 'inches',
    min: 1,
    max: 254,
    turnOffAt: 255,
    type: 'int',
  },
  {
    settingName: 'Depth Detection Threshold 2',
    field: 'depthDet2',
    metric: 'inches',
    min: 1,
    max: 254,
    turnOffAt: 255,
    type: 'int',
  },
  {
    settingName: 'Depth Detection Threshold 3',
    field: 'depthDet3',
    metric: 'inches',
    min: 1,
    max: 254,
    turnOffAt: 255,
    type: 'int',
  },
  {
    settingName: 'Depth Detection Holdoff',
    field: 'depthHoldHours',
    metric: 'hours',
    min: 0,
    max: 24,
    turnOffAt: 0,
  },
];

const RATE_MAX = parseFloat((2.54 * 60).toFixed(1));
const RATE_TURN_OFF = parseFloat((2.55 * 60).toFixed(1));

export default function ThresholdSettingsCard({
  deviceSettings,
  handleInputChange,
  device,
  enabled,
}) {
  return (
    <BaseCard
      className={`shadow-sm ${CARD_CLASS_NAMES.card}`}
      header="Threshold Settings"
      headerClassName={CARD_CLASS_NAMES.cardHeader}
      bodyClassName={`d-flex flex-column gap-2 ${CARD_CLASS_NAMES.cardBody}`}
    >
      {SIMPLE_THRESHOLDS.map(({ settingName, field, metric, min, max, turnOffAt, type }) => (
        <DeviceSetting
          key={field}
          settingName={settingName}
          settingDataName={field}
          setting={deviceSettings?.[field]}
          metric={metric}
          min={min}
          max={max}
          turnOffAt={turnOffAt}
          deviceSettings={deviceSettings}
          handleInputChange={handleInputChange}
          device={device}
          type={type}
          enabled={enabled}
          restoreValue={device?.device_settings?.[field]}
        />
      ))}
      <DeviceSetting
        settingName="Rise Rate Threshold"
        settingDataName="ffTheshold"
        setting={(deviceSettings?.ffTheshold * 60).toFixed(1)}
        metric="in/min"
        min={0}
        max={RATE_MAX}
        turnOffAt={RATE_TURN_OFF}
        step={0.6}
        deviceSettings={deviceSettings}
        handleInputChange={(field, value) =>
          handleInputChange(field, parseFloat((value / 60).toFixed(2)))
        }
        device={device}
        type="float"
        enabled={enabled}
        restoreValue={Number(((device?.device_settings?.ffTheshold ?? 0) * 60).toFixed(1))}
      />
      <DeviceSetting
        settingName="Drop Rate Threshold"
        settingDataName="dropThresh"
        setting={(deviceSettings?.dropThresh * 60).toFixed(1)}
        metric="in/min"
        min={0}
        max={RATE_MAX}
        turnOffAt={RATE_TURN_OFF}
        step={0.6}
        deviceSettings={deviceSettings}
        handleInputChange={(field, value) =>
          handleInputChange(field, parseFloat((value / 60).toFixed(2)))
        }
        device={device}
        type="float"
        enabled={enabled}
        restoreValue={Number(((device?.device_settings?.dropThresh ?? 0) * 60).toFixed(1))}
      />
    </BaseCard>
  );
}
